import React, { useState } from 'react';
import { Plus, X } from 'lucide-react';

export default function FaqSection() {
  const [openFaq, setOpenFaq] = useState(0);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    { tag: "COURSE", q: "Do I need prior experience?", a: "No. The learning paths start from the basics — money, markets and mutual funds — in simple language. Experienced investors can skip ahead to portfolio and risk modules." },
    { tag: "COURSE", q: "How much time does it take per week?", a: "Around 1-2 hours per week at your own pace." },
    { tag: "MONEY", q: "How much capital do I need to start?", a: "You can start learning with zero capital and begin investing with as little as ₹500/month via SIPs." },
    { tag: "HONESTY", q: "Will this make me rich quickly?", a: "No. Wealth building is a patient, compounding process through disciplined decisions." },
    { tag: "HONESTY", q: "Will you give me stock tips or buy-sell calls?", a: "No. We focus 100% on financial education, process and framework, not stock calls." }
  ];

  return (
    <section className="py-16 px-6 max-w-4xl mx-auto">
      <h2 className="font-serif-title text-4xl font-bold text-center text-[#0A2540] mb-12">
        The honest <span className="italic text-[#0A4D3C] font-normal">answers</span>
      </h2>

      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div key={index} className="bg-white rounded-2xl border border-gray-200/80 overflow-hidden shadow-sm">
            <button 
              onClick={() => toggleFaq(index)}
              className="w-full p-5 text-left flex justify-between items-center gap-4 hover:bg-gray-50 transition"
            >
              <div className="flex items-center gap-3">
                <span className="text-[10px] font-bold bg-[#E6F4F1] text-[#0A4D3C] px-2.5 py-1 rounded">
                  {faq.tag}
                </span>
                <span className="font-bold text-sm text-gray-900">{faq.q}</span>
              </div>
              {openFaq === index ? <X className="w-4 h-4 text-gray-500" /> : <Plus className="w-4 h-4 text-gray-500" />}
            </button>
            {openFaq === index && (
              <div className="p-5 pt-0 text-xs text-gray-600 border-t border-gray-100 bg-gray-50/50 leading-relaxed">
                {faq.a}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}